import {uiLocale} from '@/i18n/copy';

export const durationOptions = Array.from({length: 20}, (_, index) => (index + 1) * 30);
export function durationLabel(minutes) {
  const value = Number(minutes);
  return value > 0 ? `${new Intl.NumberFormat(uiLocale(), {maximumFractionDigits: 2}).format(value / 60)} h` : '—';
}
